import React from 'react';

import { Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { TYPE_OPTIONS_ENUM } from '../../constants/observations';
import { getTypeLabel } from '../../utils/observations';

const useStyles = makeStyles(() => ({
  callBackChip: {
    backgroundColor: 'white',
    border: '1px solid #FF8F00',
    color: '#FF8F00',
  },
  chip: {
    borderRadius: 100,
    fontSize: 12,
    fontWeight: 'bold',
    height: 22,
    padding: '0 4px',
  },
  routineChip: {
    backgroundColor: '#c3edff',
    border: '1px solid #0789fd',
    color: '#0789fd',
  },
  statChip: {
    backgroundColor: '#FBECEC',
    border: '1px solid red',
    color: 'red',
  },
  urgentChip: {
    backgroundColor: '#FFEBCD',
    border: '1px solid #E2A74F',
    color: '#E2A74F',
  },
}));

const TypeChip = ({ type, size = 'small', className = '' }) => {
  const classes = useStyles();

  if (!type) return null;

  const getTypeChipClass = (typeValue) => {
    switch (typeValue?.toLowerCase()) {
      case TYPE_OPTIONS_ENUM.CALL_BACK:
        return `${classes.chip} ${classes.callBackChip}`;
      case TYPE_OPTIONS_ENUM.STAT:
        return `${classes.chip} ${classes.statChip}`;
      case TYPE_OPTIONS_ENUM.URGENT:
        return `${classes.chip} ${classes.urgentChip}`;
      case TYPE_OPTIONS_ENUM.ROUTINE:
      default:
        return `${classes.chip} ${classes.routineChip}`;
    }
  };

  return <Chip label={getTypeLabel(type).toUpperCase()} size={size} className={`${getTypeChipClass(type)} ${className}`} />;
};

export default TypeChip;
